import React from 'react';
import {
  PageHeader,
  IconButton,
} from '@cochlear-design-system/foundation';

export const TopHeading = ({ headingDetails }) => {
  const { title, buttonConfig } = headingDetails;

  return (
    <div className="ccl__main-patient--header">
      <PageHeader title={title} />
      {buttonConfig && (
        <IconButton
          variant={buttonConfig.variant}
          icon={buttonConfig.icon}
          handleClick={buttonConfig.onClick}
          size={buttonConfig.size}
          analytics={buttonConfig.analytics}
        />
      )}
    </div>
  );
};
